import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatOption, MatSelect, MatSelectChange } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { Observable, Subject, Subscription, combineLatest, map } from 'rxjs';
import { CompanyUserService } from 'src/app/admin-setting/assing-company-users/company-user.service';
import { AuthService } from 'src/app/services/auth.service';
import { ExcelService } from 'src/app/shared/excel';
import { NotificationService } from 'src/app/shared/notification.service';
import { SalesReportService } from '../../services/sales-report.service';
import { SvinnReportService } from '../../services/svinn-report.service';


@Component({
  selector: 'app-sales-rerpot',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.css'],
})




export class SalesReportComponent implements OnInit, OnDestroy {

  columnTotals: { [key: string]: number } = {};
  inputDateFrom
  inputDateTo;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('select') select: MatSelect;


  systemControl = new FormControl();
  categoryControl = new FormControl();
  companyControl = new FormControl();

  selectedSystems: Array<any> = [];
  selectedCompanies: Array<any> = [];
  selectedCategories: Array<any> = []
  peiLabels = [];
  systems$: Observable<Array<any>>;
  companies$;
  companies = [];
  categories$;

  filteredSystems$;
  filteredCompanies$;
  categoriesSystems$;
  timeSelected
  exportData = [];
  selectedValuesForSystem = [];
  selectedValuesForCategories = [];
  selectedValuesForCompanies = [];
  salesDataGraph = [];
  barChartData = [];
  svinnBarChartData = [];
  pieChartData = [];
  systemsNameForChart = [];
  barChartCategories = [];
  svinnBarChartCategories = [];
  svinnReport = [];
  salesReport = [];
  systemsArray = [];
  currentItem = 'Television';

  displayedColumns: string[] = ['companyId', 'systemName', 'productName', 'Quantity', 'priceWithoutMVA', 'discountedPrice'] // Add other column names here
  customDateRange = { start: null, end: null };
  totalSale: string = ""
  totalSaleQuanity: string = ""
  isVatActive = 0;
  isCreditActive: String;
  isViewCheckActive: string = "GRAPH";
  showPieChart: Boolean = false;
  showBarChartForCompany: Boolean = false;
  showSvinnBarChartForCompany: Boolean = false;
  showBarChartForSystems: Boolean = false;
  forceLoading: boolean = false;
  allCompaniesSelected = false;
  hideTable = true;
  data = []
  dataSource = new MatTableDataSource(this.data);
  values$: Observable<any>;
  valuesSubscription: Subscription;
  filterSystemSubscription: Subscription;
  selectValue = [];
  columnSettings = [
    {
      columnId: 'name',
      name: 'Company',
      maxLengthOnMobile: 10,
    },
    {
      columnId: 'systemName',
      name: 'System',
      hideOnMobile: true
    },
    {
      columnId: 'productName',
      name: 'Product',
      hideOnMobile: true
    },
    {
      columnId: 'qty',
      name: 'Quantity',
    }, {
      columnId: 'salePrice',
      name: 'Sale Price',
    }
    , {
      columnId: 'mvaPrice',
      name: 'VAT',
    }, {
      columnId: 'salepriceWithoutMVA',
      name: 'SalePrice Exc VAT',
    }, {
      columnId: 'subsidizedExVAT',
      name: 'Subsidized Exc VAT',
    }

  ]



  systemsTableDataSub = new Subject<any[]>()

  systemsTableData = []

  columnSettingsSystemsTable = [
    {
      columnId: 'systemName',
      name: 'System',
      // maxLengthOnMobile: 10,
    },
    {
      columnId: 'systemId',
      name: 'System ID',
      // maxLengthOnMobile: 10,
    },
    {
      columnId: 'revenue',
      name: 'Revenue'
    },
    {
      columnId: 'expected',
      name: 'Expected'
    },
    {
      columnId: 'diff',
      name: 'Diff'
    }
  ]


  timeTableDataSub = new Subject<any[]>()

  timeTableData = []

  columnSettingsTimeTableData = [
    {
      columnId: 'date',
      name: 'Date'
    },
    {
      columnId: 'day',
      name: 'Day of Week'
    },
    {
      columnId: 'week',
      name: 'Week'
    },
    {
      columnId: 'revenue',
      name: 'Revenue'
    }
  ]

  constructor(private auth: AuthService,
    private notifierService: NotificationService,
    private saleService: SalesReportService,
    private salesService: SalesReportService,
    private excelService: ExcelService,
    private svinnService: SvinnReportService,
    private companyUserService: CompanyUserService
  ) {

  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    // setTimeout(() => {
    // this.systemsTableDataSub.next(this.systemsTableData)
    // });
  }



  ngOnInit(): void {
    this.systemControl.valueChanges.subscribe(values => {
      if (values.includes("selectAllSystems"))
        this.filteredSystems$.subscribe(sp => {
          values = sp.map(d => d.systemName)
          this.selectedValuesForSystem = values

        })
      else
        this.selectedValuesForSystem = values
    });

    this.categoryControl.valueChanges.subscribe(values => {
      if (values.includes("selectAllCategories"))
        this.categories$.subscribe(sp => {
          values = sp.map(d => d.name)
          this.selectedValuesForCategories = values
        })
      else
        this.selectedValuesForCategories = values
    });



    // this.select.options.forEach((item: MatOption) => item.select());


    this.auth.getUserPromise().then(user => {
      // this.salesService.getMappingByCompanyId(user.companyId).subscribe(systems => {
      //   this.systemsArray = systems;
      // })
      // this.companies$ = this.salesService.getCompanies$()
      //   .pipe(map(companies => ((user.companyId as unknown) as Array<any>).map(companyId => companies.find(company => company.companyId == companyId))))

      this.systems$ = this.salesService.getMappingByCompanyId()
        .pipe(map(systems => ((user['sites'] as unknown) as Array<any>).map(siteId => systems.filter(company => company['siteId'] == siteId)))).pipe(

          map(systems => systems.filter(x => x != undefined).flat()),
          map(systems => {

            const sortedSystems = systems.sort((a, b) => a['name'].localeCompare(b['name']));

            return sortedSystems;
          })
        )

      const cuboidId = "IbYFkxDI8RbMdRiukALO";
      // if hav 

      if (user['companyId'].includes(cuboidId)) {
        // this.selectedCompanies.push({companyId: cuboidId, name: "Cuboid AS"})
        this.selectValue = ["Frigg Øst"];

        this.setCompany({
          "name": "Frigg Øst",
          "companyId": "IbYFkxDI8RbMdRiukALO"
        }, false)

        this.timeSelected = "THIS_MONTH";

        this.setTimePeriodeEvent({ value: "THIS_MONTH" } as MatSelectChange);

        this.filterSystems(["Frigg Øst"]);
      }

      this.companies$ = combineLatest(this.auth.getUser$(), this.companyUserService.getCompanies$()).pipe(map(data => {

        const companyData = data[1].sort((a, b) => a['name'].localeCompare(b['name']))


        const cuboidIndex = companyData.findIndex(obj => obj['companyId'] == cuboidId);
        if (cuboidIndex > -1) {
          const cuboid = companyData.splice(cuboidIndex, 1);
          companyData.unshift(cuboid[0]);
        }

        const filterdCompanyData = companyData.filter(arr => {
          return data[0].companyId.includes(arr['companyId'])
        }
        );

        // If cuboid is in the list, add it to the selected companies
        // if (cuboidIndex > -1) {
        //   this.setCompany(companyData[cuboidIndex]);
        // }

        return filterdCompanyData;

      }))

      this.companies$.subscribe(companies => {
        this.companies = companies;
      })



      // this.companyControl.valueChanges.subscribe(values => {

      // });
    })




  }



  selectAllCompanies() {
    if (this.allCompaniesSelected) {
      this.select.options.forEach((item: MatOption) => item.select());

      this.companies.forEach(element => {
        this.setCompany(element, true)
      });

      // this.companies$.subscribe(sp => {
      //   this.selectedValuesForCompanies = sp.map(d => d.name)
      //   sp.forEach(element => {
      //     this.setCompany(element)
      //   });

      // })

    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
      this.selectedCompanies = []

    }
  }

  onComanySelectChange(event) {
    this.filterSystems(this.selectValue);
  }

  filterSystems(selectedCompanies) {
    this.selectedValuesForCompanies = selectedCompanies;

    this.filteredSystems$ = this.systems$.pipe(
      map(systems => systems.filter(system => {
        const companyIds = this.selectedCompanies.map(company => company.companyId);
        return companyIds.includes(system.companyId);
      }))
    );

    this.filterSystemSubscription = this.filteredSystems$.subscribe(systems => {
      this.systemsArray = systems
    })
  }

  setSystem(obj) {
    this.selectedSystems.push(obj)
  }
  setCompany(obj, force) {
    if (this.selectedCompanies.find(company => company.companyId == obj.companyId) && !force)
      this.selectedCompanies = this.selectedCompanies.filter(company => company.companyId != obj.companyId);
    else
      this.selectedCompanies.push(obj)
    if (this.selectedCompanies.length > 0)
      this.categories$ = this.svinnService.getCategories(this.selectedCompanies[0].companyId).pipe(map(categories => categories.sort((a, b) => a.name.localeCompare(b.name))));
  }
  setCategory(obj) {
    this.selectedCategories.push(obj)
  }
  vatCheck(value) {
    this.isVatActive = value;
  }
  creditCheck(value) {
    this.isCreditActive = value;
  }
  viewCheck(value) {
    this.isViewCheckActive = value;
  }


  setTimePeriodeEvent(event: MatSelectChange) {
    this.setTimePeriode(event.value);
  }

  setTimePeriode(value) {
    try {

      const now = moment();

      let from;
      let to;
      switch (value) {
        case 'TODAY':
          from = moment(now).startOf('day').unix();
          to = now.endOf('day').unix();
          break;
        case 'YESTERDAY':
          from = moment(now).subtract(1, 'days').startOf('day').unix();
          to = moment(now).subtract(1, 'days').endOf('day').unix();
          break;
        case '24H':
          from = moment(now).subtract(1, 'days').unix();
          to = moment(now).unix();
          break;
        case 'THIS_MONTH':
          from = moment(now).startOf('month').unix();
          to = moment(now).endOf('day').unix();
          break;
        case 'LAST_MONTH':
          from = moment(now).subtract(1, 'month').startOf('month').unix();
          to = moment(now).subtract(1, 'month').endOf('month').unix();
          break;
        case 'CUSTOM':
          return;
          break;
        default:
          throw new Error("Unhandled select time case!")
      }

      this.inputDateFrom = from;
      this.inputDateTo = to;


    } catch (err) {
      console.log(err.message)
    }

  }

  onSubmit() {
    try {

      if (!this.inputDateFrom && !this.inputDateFrom) {
        throw new Error("Please select time period")
      }

      this.hideTable = false;


      this.forceLoading = true;
      this.systemsNameForChart = [];
      this.salesDataGraph = [];
      this.pieChartData = []
      this.barChartCategories = []
      this.barChartData = []
      let systemArr = [];
      let categoryArr = [];
      let companyArr = [];

      let body = {}
      if (this.inputDateFrom)
        body['dateFrom'] = this.inputDateFrom
      if (this.inputDateTo)
        body['dateTo'] = this.inputDateTo
      if (this.selectedSystems.length > 0) {
        this.selectedValuesForSystem.forEach(element => {
          systemArr.push(this.selectedSystems.filter(system => system.systemName == element)[0])
        });
        this.selectedSystems = systemArr;
        systemArr = systemArr.map(system => system.systemId)
        if (systemArr.length > 0)
          body['systemId'] = systemArr //: 
        else delete body['systemId']
      }

      if (this.selectedCompanies.length > 0) {
        this.selectedValuesForCompanies.forEach(element => {

          companyArr.push(this.selectedCompanies.filter(comp => comp.name == element)[0])
        });
        if (companyArr.length > 0) body['companyId'] = companyArr.map(comp => comp.companyId);
        else delete body['companyId'];
      }

      if (this.selectedValuesForCategories.length > 0) {
        this.selectedValuesForCategories.forEach(element => {
          categoryArr.push(this.selectedCategories.filter(cat => cat.name == element)[0])

        });
        this.selectedCategories = categoryArr;
        categoryArr = categoryArr.map(cat => cat.name)
        body['categories'] = categoryArr;

      }
      body['vat'] = this.isVatActive;

      body['vat'] == 0 ? delete body['vat'] : body['vat']

      if (this.isCreditActive == 'withCredit') body['withCredit'] = 'credit'
      else if (this.isCreditActive == 'withOutCredit') body['withOutCredit'] = 'credit'
      else delete body['withOutCredit'] && delete body['withOutCredit'];
      this.showPieChart = false;
      this.showBarChartForCompany = false;
      this.showBarChartForSystems = false;

      this.salesService.getTransactionSale(body).then(saleData => {
        this.peiLabels = ["Credit"]
        if (this.isCreditActive == 'withCredit') {
          this.peiLabels = ["Credit"]
          this.pieChartData.push(saleData.creditIncome)
          this.totalSale = saleData.creditIncome + "";
          this.totalSaleQuanity = saleData.creditCount + "";
        } else if (this.isCreditActive == 'withOutCredit') {
          this.peiLabels = ["Vipps", "Stripe", "Subsidy"]
          this.pieChartData.push(Math.round(saleData['vippsIncome']))
          this.pieChartData.push(Math.round(saleData['stripeIncome']))
          this.pieChartData.push(Math.round(saleData['totalSubsidy']))
          this.totalSale = (saleData['vippsIncome'] + saleData['stripeIncome'] + saleData['totalSubsidy']).toFixed(0);
          this.totalSaleQuanity = (saleData['vippsCount'] + saleData['stripeCount']).toFixed(0);

        } else {
          this.peiLabels = ["Vipps", "Stripe", "Credit", "Subsidy"]
          this.pieChartData.push(Math.round(saleData['vippsIncome']))
          this.pieChartData.push(Math.round(saleData['stripeIncome']))
          this.pieChartData.push(Math.round(Number(saleData.creditIncome)))
          this.pieChartData.push(Math.round(saleData['totalSubsidy']))
          this.totalSale = (saleData['vippsIncome'] + saleData['stripeIncome'] + saleData.creditIncome + saleData['totalSubsidy']).toFixed(0);
          this.totalSaleQuanity = (saleData['vippsCount'] + saleData['stripeCount'] + saleData.creditCount).toFixed(0);

        }
        this.showPieChart = true;

      })
      if (this.isViewCheckActive == "LIST") {
        this.values$ = this.saleService.getListSalesReport(body).pipe(map((data) => {
          return data.map(doc => {
            return {
              ...doc,
              salepriceWithoutMVA: doc['salepriceWithoutMVA'] ? doc['salepriceWithoutMVA'].toFixed(2) : 0,
              subsidizedExVAT: doc['subsidizedExVAT'] ? doc['subsidizedExVAT'].toFixed(2) : 0,
              salePriceIncSubsidy: doc['salePriceIncSubsidy'] ? doc['salePriceIncSubsidy'].toFixed(2) : 0,
              mvaPrice: doc['mvaPrice'] ? doc['mvaPrice'].toFixed(2) : 0,
              ...this.selectedCompanies.find(company => company.companyId == doc['companyId'])
            }
          })

        }))

        this.valuesSubscription = this.values$.subscribe(data => {
          this.forceLoading = false;
          this.columnSettings.forEach(column => this.columnTotals[column.columnId] = 0);
          data.forEach(row => {
            this.columnSettings.forEach(column => {
              this.columnTotals[column.columnId] += row[column.columnId] ? Number(row[column.columnId]) : 0;
            });
          });
          this.exportData = data;
        })
      }
      if (this.isViewCheckActive == "PRODUCTVIEW") {
        
        this.values$ = this.saleService.getProductSalesReport(body).pipe(map((data) => {
          console.log(body)
          return data.map(doc => {
            return {
              ...doc,
              salepriceWithoutMVA: doc['salepriceWithoutMVA'] ? doc['salepriceWithoutMVA'].toFixed(2) : 0,
              subsidizedExVAT: doc['subsidizedExVAT'] ? doc['subsidizedExVAT'].toFixed(2) : 0,
              salePriceIncSubsidy: doc['salePriceIncSubsidy'] ? doc['salePriceIncSubsidy'].toFixed(2) : 0,
              mvaPrice: doc['mvaPrice'] ? doc['mvaPrice'].toFixed(2) : 0,
              ...this.selectedCompanies.find(company => company.companyId == doc['companyId'])
            }
          })

        }))

        this.valuesSubscription = this.values$.subscribe(data => {
          this.forceLoading = false;
            this.columnSettings = this.columnSettings.filter(column => column.columnId !== 'systemName' && column.columnId !== 'mvaPrice'&& column.columnId !== 'salePriceIncSubsidy');
            this.columnSettings.forEach(column => this.columnTotals[column.columnId] = 0);
          data.forEach(row => {
            this.columnSettings.forEach(column => {
              this.columnTotals[column.columnId] += row[column.columnId] ? Number(row[column.columnId]) : 0;
            });
          });
          this.exportData = data;
        })
      }

      else if (this.isViewCheckActive == "GRAPH") {
        this.showBarChartForCompany = false;
        this.showBarChartForSystems = false;
        this.forceLoading = false;
        let systemsByCompany = [];
        if (!body['companyId'] || body['companyId'].length == 0)
          throw new Error("Please select company")
        body['companyId'].forEach(element => {
          systemsByCompany.push(...this.systemsArray.filter(sys => sys.companyId == element))
        });
        body['systemsByCompany'] = systemsByCompany;
        this.salesService.getSalesRapportByGraphForAllSelectedSystems(body).then(snapshot => {
          let arr = (snapshot as Array<any>).map(doc => {
            return { ...this.systemsArray.find(system => system.systemId == doc.name), income: doc.income, count: doc.count }
          })
          this.dataSource.data = [];
          this.systemsTableData = [];

          const selectedSystemIds = this.selectedSystems.map(system => system.systemId);

          arr.reduce((acc, cur) => {
            if (selectedSystemIds.includes(cur.systemId) || selectedSystemIds.length === 0) {
              acc.push(cur)
            }
            return acc;
          }, []).forEach(d => {

            this.systemsTableData.push({
              systemId: d.localSystemId,
              systemName: d.name,
              revenue: Math.round(Number(d.income)),
              expected: d.garantiomsetning ? d.garantiomsetning : 0,
              diff: Math.round(Number(d.income) - Number(d.garantiomsetning ? d.garantiomsetning : 0) > 0 ? 0 : -(Number(d.income) - Number(d.garantiomsetning ? d.garantiomsetning : 0))),
            })


            const name = (d.name.length > 10 ? d.name.substring(0, 10) + "..." : d.name).replace(/_/g, ' ');

            this.salesDataGraph.push({
              x: name,
              y: Number(d.income).toFixed(0),
              active: d.active,
              goals: [
                {
                  name: "Expected",
                  value: d.garantiomsetning ? d.garantiomsetning : 0,//this.getRandomValue(),
                  // strokeWidth: 5,
                  strokeColor: "#FFA500"
                },
                {
                  name: "Diff",
                  value: Math.round(Number(d.income) - Number(d.garantiomsetning ? d.garantiomsetning : 0) > 0 ? 0 : -(Number(d.income) - Number(d.garantiomsetning ? d.garantiomsetning : 0))),
                  strokeColor: "#FF4560"
                }
              ]
            })



          })

          // This is not the way to do it, but it works for now
          setTimeout(() => {
            this.systemsTableDataSub.next(this.systemsTableData)
          }, 5000);

          this.salesDataGraph = this.salesDataGraph.filter(system => system.active).sort((a, b) => b.y - a.y)
          // this.salesDataGraph = this.salesDataGraph.filter(system => system.active).sort((a, b) => a.x.localeCompare(b.x))
          this.showBarChartForSystems = true;

        })
        let newBody = []
        if (body['companyId'])
          body['companyId'].forEach(element => {
            newBody.push({ ...body, name: companyArr.find(c => c.companyId == element)['name'], companyId: [element] })
          });

        const promises = newBody.map((data) => this.saleService.getTimeIntervals(data, data['dateFrom'], data['dateTo'], "SALE"));
        Promise.all(promises).then(results => {

          results.forEach(data => {
            this.barChartCategories = []
            this.timeTableData = [];

            this.timeTableData = [];

            data.forEach(d => {
              this.timeTableData.push({
                date: moment.unix(d.startUnix).format('DD.MM.YYYY'),
                day: moment.unix(d.startUnix).format('dddd'),
                week: moment.unix(d.startUnix).week(),
                revenue: d.serverData.income ? Math.round(d.serverData.income) : 0
              });
            })

            this.barChartData.push({
              name: companyArr.find(c => c.companyId == data[0]['body']['companyId']).name,
              data: data.map(d => d.serverData.income ? d.serverData.income.toFixed(0) : d.serverData.income)
            })
            data.map(d => this.barChartCategories.push(d.formatted))
          })

          this.showBarChartForCompany = true;

        });

        setTimeout(() => {
          this.timeTableDataSub.next(this.timeTableData);
        }, 5000);
      }

      else if (this.isViewCheckActive == "CATGRAPH") {
        this.showBarChartForCompany = false;
        this.showBarChartForSystems = false;
        this.showSvinnBarChartForCompany = false;

        this.forceLoading = false;
        let systemsByCompany = [];
        if (!body['companyId'] || body['companyId'].length == 0)
          throw new Error("Please select company")
        body['companyId'].forEach(element => {
          systemsByCompany.push(...this.systemsArray.filter(sys => sys.companyId == element))
        });
        body['systemsByCompany'] = systemsByCompany;


        this.salesService.getSalesRapportByGraphForSelectedCategories(body).then(snapshot => {
          let arr = (snapshot as Array<any>).map(doc => {
            return { ...this.systemsArray.find(system => system.systemId == doc.name), income: doc.income, count: doc.count, category: doc.category }
          })
          this.dataSource.data = [];

          this.salesDataGraph = arr;// snapshot as any
          this.showBarChartForSystems = true;

        })
        let newBody = [];
        this.svinnReport = [];
        this.salesReport = [];
        if (body['companyId'])
          body['companyId'].forEach(element => {
            body['categories'].forEach(category => {
              newBody.push({ ...body, categories: [category], name: companyArr.find(c => c.companyId == element)['name'], companyId: [element] });
            })
          });

        let svinnNewBodyData = []
        body['companyId'].forEach(element => {
          body['categories'].forEach(category => {
            svinnNewBodyData.push({ ...body, categories: [category], name: companyArr.find(c => c.companyId == element)['name'], companyId: [element] });
          })
        });

        const promises = newBody.map((data) => this.saleService.getTimeIntervals(data, data['dateFrom'], data['dateTo'], "SALE"));
        Promise.all(promises).then(results => {
          this.salesReport = results;
        });


        const promises1 = svinnNewBodyData.map((data) => {
          return this.saleService.getTimeIntervals(data, data['dateFrom'], data['dateTo'], "SVINN")
        }
        );
        Promise.all(promises1).then(results => {
          this.svinnReport = results;
        });
      }
    } catch (error) {
      console.log(error)
      this.notifierService.showNotification('error', error.message);

    }

  }


  calculateColumnTotals() {
    this.dataSource.data.forEach(row => {
      this.displayedColumns.forEach(column => {
        this.columnTotals[column] += row[column] ? Number(row[column]) : 0;

      });
    });
    this.exportData = this.dataSource.data;
  }



  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {
    if (picker === 'start') {
      this.inputDateFrom = moment(event.value).startOf('day').unix();
    } else {
      this.inputDateTo = moment(event.value).endOf('day').unix()
    }
  }

  displayedColumn() {
    return this.columnSettings.map(columnSetting => columnSetting.columnId);

  }
  getRandomValue(): number {
    const min = 30000;
    const max = 40000;
    const range = 1000;
    const randomValue = Math.floor(Math.random() * ((max - min) / range + 1)) * range + min;
    return randomValue;
  }

  exportToExcel() {

    let fixedData: any[] = [];

    const columnNames = this.displayedColumns.map(c => c)
    const columnIds = this.displayedColumns.map(c => c)

    fixedData = this.exportData.map(_line => {
      let line = { ..._line };

      Object.keys(line).forEach((key) => {
        if (!columnIds.includes(key)) {
          delete line[key];
        }
        else {
          const tempValue = line[key];
          const i = columnIds.indexOf(key);
          if (columnNames[i] !== key) {
            line[columnNames[i]] = tempValue;
            delete line[key];
          }
        }
      })
      return line;
    })

    this.excelService.exportAsExcelFile(fixedData, moment().tz('Europe/Oslo').format('DD-MM-YYYY_HH:mm:ssZZ'));
  }

  ngOnDestroy(): void {
    if (this.valuesSubscription)
      this.valuesSubscription.unsubscribe()
    if (this.filterSystemSubscription)
      this.filterSystemSubscription.unsubscribe()
  }

}

